import type {AreaRouteSegments} from '@widgets/area-dashboard'
import {HrocChecklistsPathSegments} from '@widgets/hroc-checklists'

import {
  HPRODUCE_HROC,
  CHECKLISTS,
  OPTIMIZATION_SPECIALIST_DASHBOARD,
  RELIABILITY_ENGINEER_DASHBOARD,
  PLANT_RELIABILITY_ENGINEER_DASHBOARD,
  PROCESS_ENGINEER_DASHBOARD,
  PLANT_PROCESS_ENGINEER_DASHBOARD,
  PLANT_OPTIMIZATION_SPECIALIST_DASHBOARD,
  MAJOR_OUTAGE_LEAD_DASHBOARD,
  PLANT_MAJOR_OUTAGE_LEAD_DASHBOARD
} from '../../shared/routes/routes'

export {
  CHECKLISTS,
  OPTIMIZATION_SPECIALIST_DASHBOARD,
  RELIABILITY_ENGINEER_DASHBOARD,
  PLANT_RELIABILITY_ENGINEER_DASHBOARD,
  PROCESS_ENGINEER_DASHBOARD,
  PLANT_PROCESS_ENGINEER_DASHBOARD,
  PLANT_OPTIMIZATION_SPECIALIST_DASHBOARD,
  MAJOR_OUTAGE_LEAD_DASHBOARD,
  PLANT_MAJOR_OUTAGE_LEAD_DASHBOARD
}

export const PLANT_CHECKLISTS_TEMPLATES = `${CHECKLISTS}/plant/:plantId/templates`
export const PLANT_CHECKLIST = `${PLANT_CHECKLISTS_TEMPLATES}/${HrocChecklistsPathSegments.Checklist}`
export const PLANT_CHECKLIST_UNSUPPORTED_KIND = `${PLANT_CHECKLIST}/${HrocChecklistsPathSegments.UnsupportedKind}`

export const RCFA_COMPLIANCE = `${HPRODUCE_HROC}/rcfa-compliance`

export const PERFORMANCE_REVIEW = `${HPRODUCE_HROC}/performance-review`
export const PLANT_PERFORMANCE_REVIEW = `${PERFORMANCE_REVIEW}/plant/:plantId`

export const SYSTEMS_ENGINEER_DASHBOARD = `${HPRODUCE_HROC}/systems-engineer-dashboard`
export const PLANT_SYSTEMS_ENGINEER_DASHBOARD = `${SYSTEMS_ENGINEER_DASHBOARD}/plant/:plantId`

export const SERVICE_LEVEL_AGREEMENT_DASHBOARD = `${HPRODUCE_HROC}/sla-tracking-dashboard`
export const PLANT_SERVICE_LEVEL_AGREEMENT_DASHBOARD = `${SERVICE_LEVEL_AGREEMENT_DASHBOARD}/plant/:plantId`

export const JOBS_TO_BE_DONE_DASHBOARD = `${HPRODUCE_HROC}/jobs-to-be-done`
export const PLANT_JOBS_TO_BE_DONE_DASHBOARD = `${JOBS_TO_BE_DONE_DASHBOARD}/plant/:plantId`

export enum HierarchyRouteSegment {
  AREA = 'area',
  PLANT = 'plant'
}

export const AREA_ROUTE_SEGMENTS: AreaRouteSegments = {
  area: HierarchyRouteSegment.AREA,
  plant: HierarchyRouteSegment.PLANT
}
